<template>
<div class="arrived-index ">
    <div class="arrived-content w">
        <div class="tab-header">
            <div 
                class="tab-item" 
                :class="{ active: arrived_state === '1' }" 
                @click="switchTab('1')"
            >
                今日到货
            </div>
            <!-- <div 
                class="tab-item" 
                :class="{ active: arrived_state === '2' }" 
                @click="switchTab('2')"
                v-if="showArrivedTab()"
            >
                即将到货
            </div>
            <div 
                v-if="$store.state.store_id=='1780'"
                class="tab-item" 
                :class="{ active: arrived_state === '3' }" 
                @click="switchTab('3')"
            >
                延期到货
            </div>  -->
        </div>
        <!-- 顶部信息栏 -->
        <div class="top-info">
            <div class="total-count">{{ arrived_state === '1' ? '今日到货' : arrived_state === '2' ? '即将到货' : '延期到货' }}：
                <span class="value">{{ allTotal }}</span>
            </div>
            <div class="search-box">
                <el-input 
                    v-model="searchText" 
                    placeholder="搜索配件" 
                    clearable
                    size="small"
                    @keyup.enter="handleSearch"
                >
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                    <el-button 
                        slot="append" 
                        type="primary" 
                        size="small" 
                        @click="handleSearch"
                    >搜索</el-button>
                </el-input>
            </div>
        </div>

        <!-- 品牌列表 -->
        <div class="brand-logo-list" v-if="brandList && brandList.length > 0">
            <div class="brand-list-wrapper" :style="{'height': brandExpandH}">
                <el-row :gutter="15">
                    <el-col v-for="(brand, i) in brandList" :key="i" :span="3">
                        <div 
                            class="img-box" 
                            :class="{ 'selected': selectedBrand === brand.oenaturebrand }"
                            @click="getListByBrand(brand.oenaturebrand)"
                        >
                           
                            <el-image :src="`https://huanuowei.cn/images/hnw/web/brand/${brand.oenaturebrand}.png`">
                                <div slot="error" class="image-slot">
                                    {{ brand.oenaturebrand }}
                                </div>
                                
                            </el-image>
                            <div class="brand-num">{{ brand.num }}</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <div class="toggle" v-if="brandList.length > 4" @click="toggleBrandExpand">
                <div class="toggle-button" >
                    <i :class="brandExpandH=='auto' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    <div class="toggle-text">{{ brandExpandH=='auto' ? '收起' : '展开' }}</div>
                </div>
            </div>
        </div>
        
        <!-- 名称列表 -->
        <div class="goods-names-list" v-if="goodsNamesList && goodsNamesList.length > 0">
            <div class="names-list-wrapper" :style="{'height': goodsNameExpandH}">
                <span 
                    v-for="(name, index) in goodsNamesList" 
                    :key="index"
                    class="name-item" 
                    :class="{ 'active': selectedGoodsName === name }"
                    @click="getListByGoodsName(name)"
                >
                    {{ name }}
                </span>
            </div>
            <div class="toggle" v-if="goodsNamesList.length > 4" @click="toggleGoodsNameExpand">
               
                <div class="toggle-button" >
                    <i :class="goodsNameExpandH=='auto' ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                    <div class="toggle-text">{{ goodsNameExpandH=='auto' ? '收起' : '展开' }}</div>
                </div>
            </div>
        </div>
        
        <!-- 配件列表组件 -->
        <GoodsList 
            :goods-list="arrivedList"
            :total="total"
            :current-page="currentPage"
            :page-size="pageSize"
            :ac-sort="acSort"
            :arrived-state="arrived_state"
            @sort="sortChange"
            @page-change="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
            
        />
        
    </div>

</div>
</template>

<script>
import GoodsList from '../../components/GoodsList.vue';

export default {
    components: {
        GoodsList
    },
    data(){
        return{
            brandList: [
                
            ],
            goodsNamesList: [],
            selectedGoodsName: '',
            brandExpandH: "138px",
            goodsNameExpandH: "auto",
            arrived_state:"1",
            selectedBrand: '',
            arrivedList: [],
            total: 0,
            allTotal: 0,
            currentPage: 1,
            pageSize: 10,
            searchText: '',
            // 排序相关
            acSort: ''
        }
    },
    methods:{
        // 排序变化（接收组件事件）
        async sortChange({ field, order }) {
            let sort_way = order;
            let sort_type = field;
            this.acSort = sort_type + sort_way;
            this.currentPage = 1;
            this.getArrivedList({});
        },
        // 切换tab
        switchTab(state) {
            this.arrived_state = state;
            this.getArrivedList({ 
                type: 'screen'
            });
        },
        // 显示到货tab
        showArrivedTab(){
            return "1989,1780,".includes(this.$store.state.store_id) ;
        },
        // 获取到货列表
        async getArrivedList(params) {
            let searParams = {
                store_curpage: this.currentPage,
                store_page: this.pageSize,
                arrived_state: this.arrived_state,
                goods_name: this.selectedGoodsName,
                oenaturebrand: this.selectedBrand,
                ...params
            };
            
            // 如果有排序，添加排序参数
            if (this.acSort) {
                if (this.acSort.includes('goods_storage')) {
                    searParams.sort_type = 'goods_storage';
                    searParams.sort_way = this.acSort === 'goods_storage1' ? '2' : '1';
                } else if (this.acSort.includes('goods_price')) {
                    searParams.sort_type = 'goods_price';
                    searParams.sort_way = this.acSort === 'goods_price1' ? '2' : '1';
                } else if (this.acSort.includes('oecode')) {
                    searParams.sort_type = 'oecode';
                    searParams.sort_way = this.acSort === 'oecode1' ? '2' : '1';
                } else if (this.acSort.includes('goods_name')) {
                    searParams.sort_type = 'goods_name';
                    searParams.sort_way = this.acSort === 'goods_name1' ? '2' : '1';
                } else if (this.acSort.includes('sccode')) {
                    searParams.sort_type = 'sccode';
                    searParams.sort_way = this.acSort === 'sccode1' ? '2' : '1';
                } else if (this.acSort.includes('oenaturebrand')) {
                    searParams.sort_type = 'oenaturebrand';
                    searParams.sort_way = this.acSort === 'oenaturebrand1' ? '2' : '1';
                }
            }
            
            let res = await this.$api.getArrivedTodaySearch({
                ...searParams
            });
            
            // 初始化商品数据
            if (res.data[0] && res.data[0].goods_list) {
                // 查询到货提醒记录
                let resArrival = await this.$api.select_goods_arrival_list({
                    member_id: this.$store.state.member_id,
                    goods_id:  res.data[0].goods_list.map(item => item.goods_id).join(',')
                });
                console.log();
                let resArrivalIds = '';
                if (resArrival&&resArrival.length > 0)  {
                    resArrivalIds = resArrival.map(item => item.goods_id).join(',');
                }
                res.data[0].goods_list.forEach(item => {
                    if(resArrivalIds.includes(item.goods_id)){
                        item.isArrivalRemind = true;
                    }else{
                        item.isArrivalRemind = false;
                    }
                    item.goods_price = this.$handlePrice(item);
                    // 初始化商品数量
                    this.$set(item, "goods_num", 1);
                    // 初始化购物车数量
                    this.$set(item, "cartNum", 0);
                    // 初始化互换件弹窗状态
                    this.$set(item, "replacePopVis", false);
                });
                this.arrivedList = res.data[0].goods_list;
                this.total = Number(res.data[0].total);
            } else {
                this.arrivedList = [];
                this.total = 0;
            }
            
            // 保持品牌列表不变
            // 1
            if (params.type=='screen') {
                this.allTotal = Number(res.data[0].total);
                const brandOrder = ['卢卡斯', 'ATI', 'SCAEG', 'HNW', '崇芳'];
                let orgList = res.oenaturebrandList || [];
                let topBrands = [];
                let otherBrands = [];
                orgList.forEach(item => {
                    let idx = brandOrder.indexOf(item.oenaturebrand);
                    if (idx > -1) {
                        topBrands.push(item);
                    } else {
                        otherBrands.push(item);
                    }
                });
                topBrands.sort((a, b) => brandOrder.indexOf(a.oenaturebrand) - brandOrder.indexOf(b.oenaturebrand));
                this.brandList = [...topBrands, ...otherBrands];
            }else{
                
            }
            
            if(!params.goods_name&&this.selectedGoodsName==''){
                this.goodsNamesList = res.goods_names || [];
            }
        },
        
        toggleBrandExpand() {
            this.brandExpandH = this.brandExpandH == "auto" ? "138px" : "auto";
        },
        
        toggleGoodsNameExpand() {
            this.goodsNameExpandH = this.goodsNameExpandH == "auto" ? "30px" : "auto";
        },
        
        getListByGoodsName(name) {
            if (this.selectedGoodsName === name) {
                this.selectedGoodsName = '';
                this.currentPage = 1;
                this.getArrivedList({});
            } else {
                this.selectedGoodsName = name;
                this.currentPage = 1;
                this.getArrivedList({});
            }
        },
        
        // 按品牌筛选
        getListByBrand(brand) {
            this.selectedGoodsName = '';
            // 如果点击的是当前已选中的品牌，则取消选中
            if (this.selectedBrand === brand) {
                this.selectedBrand = '';
                this.currentPage = 1;
                this.getArrivedList({});
            } else {
                this.selectedBrand = brand;
                this.currentPage = 1;
                this.getArrivedList({});
            }
        },
        
        // 搜索功能
        handleSearch() {
            this.currentPage = 1;
            this.getArrivedList({ search: this.searchText });
        },
        
        // 分页处理
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getArrivedList({ 
                oenaturebrand: this.selectedBrand, 
                search: this.searchText 
            });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getArrivedList({ 
                oenaturebrand: this.selectedBrand, 
                search: this.searchText 
            });
        }
        
    },
    async created(){
        
        await this.getArrivedList({
            type: "screen"
        });

        this.$api.getAnalysisLogNew({
            page: "arrived",
            module: '1',
            click_count: 1
        })
    },
    props:{
        
    }
}
</script>

<style lang="scss">
.arrived-index{
    // padding: 10px;
    padding-top: 5px;
    background: #f5f5f5;
    .arrived-content{
    .tab-header {
            display: flex;
            background: #fff;
            border-bottom: 1px solid #e4e4e4;
            padding: 0 30px;
            .tab-item {
                padding: 12px 0;
                margin-right: 30px;
                cursor: pointer;
                font-size: 16px;
                color: #666;
                border-bottom: 2px solid transparent;
                &.active {
                    color: #3E84D6;
                    border-bottom: 2px solid #3E84D6;
                    font-weight: bold;
                }
            }
            
            .search-container {
                margin-left: auto;
                display: flex;
                align-items: center;
                
              
                // 调整输入框高度
                .el-input__inner {
                    height: 32px;
                    line-height: 32px;
                    border-radius: 0;
                }
                
                .el-button {
                    height: 32px;
                    min-width: 80px;
                    line-height: 32px;
                    padding: 0 5px;
                    box-sizing: border-box;
                }
                .search-box{
                }
            }
        }
        .top-info{
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 5px;
            padding: 5px 10px;
            background: #fff;
            border-radius: 4px;
            
            .total-count{
                
                font-weight: bold;
                color: #333;
                .value{
                    color: red;
                }
            }
            
            .search-box{
                .el-input{
                    width: 320px;
                }
                
                .el-input__prefix{
                    left: 10px;
                }
                
                .el-input__append{
                    padding-right: 5px;
                }
                
                .el-button{
                    padding: 0 12px;
                    font-size: 14px;
                }
            }
        }
        
        .brand-logo-list{
            margin-bottom: 10px;
            background: #fff;
            padding: 10px ;
            position: relative;
            .el-col{
                height: 140px;
            }
            .img-box{
                position: relative;
                text-align: center;
                margin-bottom: 10px;
                box-shadow: 0px 1px 6px 0px rgba(0,0,0,0.07);
                border-radius: 4px;
                cursor: pointer;
                transition: all 0.3s ease;
                box-sizing: border-box;
                height: 134px;
                // overflow: hidden;
                // height: 30px;
                // margin-bottom: 5px;
                // img{
                //     width: 68px;
                //     position: relative;
                //     top: -10px;
                //     left: -10px;
                // }
                // .image-slot{
                //     line-height: 30px;
                // }
                .el-image{
                    width: 100%;
                    .image-slot{
                        height: 100%;
                        line-height: 134px;
                        text-align: center;
                        font-weight: bold;
                        color: #063376;
                    }
                }
                img{
                    width: 100%;
                    
                    object-fit: contain;
                    
                }
                
                
                .brand-num {
                    position: absolute;
                    background: url(../../assets/newHome/折扣.png);
                    background-size: 40px 20px;
                    width: 40px;
                    height: 20px;
                    right: 0px;
                    top: 3px;
                    text-align: center;
                    line-height: 20px;
                    font-family: Source Han Sans CN;
                    font-weight: 500;
                    font-size: 12px;
                    color: #FFFFFF;
                    z-index: 99;
                    transform: scale(0.8);
                }
                
                &.selected {
                    border: 1px solid #3E84D6;
                    box-shadow: 0 0 10px rgba(62, 132, 214, 0.5);
                }
            }
        }
        
        .brand-list-wrapper {
            overflow: hidden;
            transition: height 0.3s ease;
        }
        
        .brand-logo-list .toggle {
            text-align: center;
            cursor: pointer;
            color: #666;
            font-size: 16px;
            &:hover {
                color: #3E84D6;
            }
           
        }
        
        .goods-names-list {
            margin-bottom: 10px;
            background: #fff;
            padding: 10px;
            display: flex;
            flex-wrap: wrap;
            position: relative;
            border: 1px solid #ddd;
            .names-list-wrapper {
                display: flex;
                flex-wrap: wrap;
                overflow: hidden;
                transition: height 0.3s ease;
                width: 100%;
            }
            .name-item {
                padding: 2px 12px;
                margin: 5px;
                border: 1px solid #ddd;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                transition: all 0.3s ease;
                &:hover {
                    border-color: #3E84D6;
                    color: #3E84D6;
                }
                &.active {
                    background: #3E84D6;
                    border-color: #3E84D6;
                    color: #fff;
                }
            }
            .toggle {
                text-align: center;
                cursor: pointer;
                color: #666;
                font-size: 16px;
                width: 100%;
                &:hover {
                    color: #3E84D6;
                }
                
            }
        }
        
        .parts-list{
            
            background: #fff;
            // 表头样式
                .parts-head {
                    height: 40px;
                    background: #c4c9cc;
                    .teble-head {
                        display: flex;
                        li {
                            display: flex;
                            height: 40px;
                            justify-content: center;
                            align-items: center;
                            position: relative;
                            color: #666;
                            &.oecode {
                                min-width: 250px;
                                max-width: 250px;
                            }
                            &.goods_name {
                                min-width: 180px;
                                max-width: 180px;
                            }
                            &.sccode {
                                min-width: 120px;
                                max-width: 120px;
                            }
                            &.oenaturebrand {
                                min-width: 120px;
                                max-width: 120px;
                            }
                            &.goods_storage {
                                width: 150px;
                            }
                            &.goods_price {
                                width: 82px;
                                position: relative;
                            }
                            .ico {
                                display: flex;
                                flex-direction: column;
                                justify-content: center;
                                align-items: center;
                                margin-left: 5px;
                                > i {
                                    cursor: pointer;
                                    font-size: 12px;
                                }
                                i:hover {
                                    transform: scale(1.5);
                                    color: #3E84D6;
                                }
                                .el-icon-caret-top {
                                    position: relative;
                                    top: 3px;
                                }
                                .el-icon-caret-bottom {
                                    position: relative;
                                    top: -3px;
                                }
                                .active {
                                    color: #3E84D6;
                                }
                            }
                            &.spec {
                                width: 90px;
                            }
                            &.goods_num {
                                width: 114px;
                            }
                            &.handle-box {
                                width: 86px;
                            }
                        }
                    }
                }
    
                .goods-body {
                    display: flex;
                    box-sizing: border-box;
                    position: relative;
                    box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
                    margin-bottom: 20px;
                    > ul {
                        width: 100%;
                    }
                    .part-list {
                        &.isAll {
                            height: auto;
                        }
                    }
                    .part-list:nth-child(2n) {
                        background: #f7f7f7;
                    }
                    
                    .part-row {
                        display: flex;
                        position: relative;
                        .watermark-text{
                            position: absolute;
                            left: 20%;
                            top: 20%;
                        }
                        .watermark-text2{
                            left: 68%;
                        }
                        >div{
                            box-sizing: border-box;
                        }
                        .isOe {
                            position: relative;
                            width: 250px;
                            border-right: 1px solid #e3e4ea;
                            display: flex;
                            justify-content: space-between;
                            
                            .isOe-left {
                                width: 98%;
                                .isOe-top {
                                    display: flex;
                                    margin-top: 14px;
                                    margin-bottom: 10px;
                                    margin-left: 10px;
                                    position: relative;
                                    .hnw-copy{
                                        position: absolute;
                                        right: 36px;
                                        top: -6px;
                                    }
                                    .name {
                                        width: 48px;
                                        height: 20px;
                                        background-color: #3E84D6;
                                        font-size: 12px;
                                        text-align: center;
                                        line-height: 20px;
                                        color: #fff;
                                    }
                                    .number {
                                        cursor: pointer;
                                        max-width: 100px;
                                        margin-left: 5px;
                                        margin-top: 2px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        white-space: nowrap;
                                        padding-top: 0;
                                        color: #333;
                                    }
                                    .tag-icon {
                                        display: flex;
                                        align-items: center;
                                        transform: scale(0.7);
                                        justify-content: center;
                                        width: 20px;
                                        height: 20px;
                                        background: #3E84D6;
                                        color: #fff;
                                        border-radius: 50%;
                                        font-size: 12px;
                                        position: relative;
                                        top: -8px;
                                        left: 2px;
                                    }
                                }
                                .vehicleModel {
                                    margin: 0 0 0 10px;
                                    max-width: 230px;
                                    box-sizing: border-box;
                                    white-space: nowrap;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    cursor: pointer;
                                    font-size: 14px;
                                    color: #999;
                                }
                            }
                        }
    
                        .goods_name {
                            width: 180px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            position: relative;
                            gap: 2px;
                            .ellipsis-text{
                                width: 94%;
                                height: 16px;
                                text-align: center;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            .product-top{
                                position: absolute;
                                right: 0px;
                                top: 0px;
                                display: flex;
                                align-items: center;
                                padding-right: 5px;
                                >div{
                                    cursor: pointer;
                                }
                                .dis-good-tips-small {
                                    background: url(../../assets/newHome/折扣.png);
                                    background-size: 40px 20px;
                                    width: 40px;
                                    height: 20px;
                                    margin-left: 6px;
                                    text-align: center;
                                    line-height: 20px;
                                    font-family: Source Han Sans CN;
                                    font-weight: 500;
                                    font-size: 12px;
                                    color: #FFFFFF;
                                    z-index: 99;
                                }
                                .cx-icon{
                                    width: 22px;
                                    margin-left: 8px;
                                }
                            }
                            .share-btn{
                                line-height: 1;
                                margin-left: 6px;
                                
                                img{
                                    width: 20px;
                                }
                            }
                            .delivery-time{
                               
                                
                            }
                        }
    
                        .sccode {
                            width: 120px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            position: relative;
                            .ellipsis-text{
                                width: 94%;
                                text-align: center;
                                height: 16px;
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                            }
                            .hnw-copy{
                                position: absolute;
                                right: 20px;
                                top: 8px;
                            }
                        }
                        
                        .oenaturebrand {
                            overflow: hidden;
                            width: 120px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            text-overflow: ellipsis;
                            position: relative;
                            .hnw-self-brand {
                                position: absolute;
                                bottom: -25px;
                                left: 50%;
                                transform: translateX(-50%);
                                color: #ff7519;
                            }
                        }
                        
                        // 自选品牌
                        .selfBrand {
                            background: #d9ecff;
                            border-bottom: 1px solid #ccc;
                        }
                        
                        .goods_storage {
                            width: 150px;
                            box-sizing: border-box;
                            border-right: 1px solid #e3e4ea;
                            text-align: center;
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;
                            padding: 5px 0;
                            .goods-location{
                                >div{
                                    color: #2473FF;
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;
                                    margin-right: 3px;
                                }
                            }
                            .loca-btn{
                                cursor: pointer;
                                padding: 1px;
                                color: #fff;
                                background: #FFAB00;
                                width: 66px;
                                text-align: center;
                                margin: 2px auto 0;
                            }
                            .goods-cangTip{
                                color: #F94F4C;
                                font-size: 12px;
                                margin-left: 5px;
                                font-weight: bold;
                            }
                        }
                        
                        .arrival-btn-box {
                            padding-top: 2px;
                            width: 100%;
                            box-sizing: border-box;
                            // border-right: 1px solid #e3e4ea;
                            display: flex;
                          
                            justify-content: center;
                            align-items: center;
                            // padding: 5px;
                            // gap: 5px;
                            .el-button {
                                padding: 4px 8px;
                                font-size: 12px;
                            }
                        }
                        
                        .goods_price {
                            position: relative;
                            width: 82px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            text-overflow: ellipsis;
                            .watermark-text{
                                right: 0px !important;
                                top: -4px;
                            }
                            span {
                                position: relative;
                                top: 1px;
                            }
                        }
    
                        .spec {
                            overflow: hidden;
                            width: 90px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            text-overflow: ellipsis;
                        }
    
                        .goods_num {
                            width: 114px;
                            height: 69px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                            border-right: 1px solid #e3e4ea;
                            position: relative;
                            .el-input-number {
                                // margin: 0 0px 0 10px;
                                width: 100px;
                            }
                            .goods-Fcl-tit {
                                position: absolute;
                                left: 50%;
                                transform: translateX(-50%);
                                bottom: 2px;
                                font-size: 12px;
                                line-height: 12px;
                                width: 120px;
                                text-align: center;
                                color: #999;
                            }
                            .red {
                                color: red;
                            }
                        }
    
                        .handle-box {
                            position: relative;
                            box-sizing: border-box;
                            padding: 5px 0;
                            width: 86px;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .addition {
                                font-size: 14px;
                                color: #999;
                                margin: 3px 0;
                            }
                            .replace-btn {
                                color: #3E84D6;
                                cursor: pointer;
                            }
                            .add-btn {
                                width: 80px;
                                height: 22px;
                                padding: 0;
                                color: #59a8f8;
                                font-size: 14px;
                                font-weight: 400;
                                line-height: 20px;
                                border-radius: 0px;
                                text-align: center;
                                cursor: pointer;
                            }
                            .add-btn:active{
                                transform: scale(1.1);
                            }
                            .ycg-btn {
                                background: #f5f5f5;
                                color: #999;
                                border: 1px solid #dcdfe6;
                            }
                        }
                    }
                    
                    .goods-ex-msg {
                        display: flex;
                        border-top: 1px solid #e3e4ea;
                        justify-content: flex-end;
                        align-items: center;
                        line-height: 30px;
                        height: 30px;
                        .buyHis {
                            cursor: pointer;
                            text-align: right;
                            padding: 0 5px;
                            color: red;
                            font-size: 12px;
                            > span {
                                margin-right: 10px;
                                align-items: center;
                            }
                            .readMore {
                                cursor: pointer;
                            }
                        }
                    }
                }
            
            .pages{
                text-align: right;
                margin-top: 20px;
            }
        }
        
        // 货位详情样式
        .alltion {
            display: flex;
            margin-bottom: 10px;
            div {
                flex: 1;
                text-align: center;
                padding: 5px 0;
                &.item {
                    border-bottom: 1px solid #f0f0f0;
                }
            }
        }
        
        // 历史购买记录样式
        .his-list {
            .list-head {
                display: flex;
                background: #f5f5f5;
                padding: 10px 0;
                div {
                    flex: 1;
                    text-align: center;
                    font-weight: bold;
                    &.col-100 {
                        width: 100px;
                    }
                }
            }
            .list-body {
                .row {
                    display: flex;
                    padding: 10px 0;
                    border-bottom: 1px solid #f0f0f0;
                    div {
                        flex: 1;
                        text-align: center;
                        &.col-100 {
                            width: 100px;
                        }
                    }
                }
            }
        }
    }
}
</style>